import axios from 'axios'

const api = axios.create({
  baseURL: process.env['VUE_APP_BASE_URL_' + process.env.NODE_ENV.toUpperCase()],
  timeout: 540000
})

export {
  api
}
